// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.creators-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-auto-rows: 1fr;
  grid-gap: 40px 20px;
  place-items: stretch;
}
.creators-grid .topic-creator-card {
  max-width: 330px;
}

.creators-grid-highlight {
  display: flex;
  flex: 1 1;
}
.creators-grid-highlight a {
  padding: 0;
}

.creators-list {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
}
.creators-list .creators-list-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1;
}
.creators-list .creators-list-header.with-tiktok, .creators-list .creators-list-header.with-twitch {
  grid-template-columns: 24px 66px 230px repeat(7, 1fr) 180px;
}
.creators-list .creators-list-header.default {
  grid-template-columns: 24px 66px 230px repeat(5, 1fr) 180px;
}
.creators-list .creators-list-header.with-twitch-tiktok {
  grid-template-columns: 24px 66px 230px repeat(9, 1fr) 180px;
}
.creators-list .creators-list-header.custom-header {
  grid-template-columns: 36px 66px 230px repeat(5, 1fr);
}
.creators-list .creators-list-header .custom-header-label-selected {
  color: var(--color_primary_500);
}
.creators-list .creators-list-header {
  background: var(--background);
  border-radius: 4px;
  font-weight: bold;
  display: grid;
  grid-column-gap: 8px;
  align-items: center;
  justify-items: left;
  height: 36px;
  padding: 0 8px;
  color: var(--gray_dark1);
  font-size: 12px;
  margin: 0 0 4px;
}
.creators-list .creators-list-header .list-header-tooltip {
  display: flex;
  align-items: center;
}
.creators-list .creators-list-header .list-header-tooltip .QuestionMarkTooltip {
  margin-left: 8px;
}
.creators-list .creators-list-header > div {
  display: flex;
  align-items: center;
  gap: 4px;
}
.creators-list .creators-list-header .provider {
  margin: 0 4px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.creators-list .creators-list-header .engag-ratio {
  display: flex;
  align-items: center;
}
.creators-list .creators-list-header .engag-ratio span {
  margin-right: 4px;
}

.header-modal-creators {
  color: #4c5667;
}`, "",{"version":3,"sources":["webpack://./src/components/CreatorsGrid/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,4DAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;AACF;AACE;EACE,gBAAA;AACJ;;AAGA;EACE,aAAA;EACA,SAAA;AAAF;AAEE;EACE,UAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,aAAA;EACA,0BAAA;AADF;AAGE;EACE,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,UAAA;AADJ;AAGI;EAEE,2DAAA;AAFN;AAKI;EACE,2DAAA;AAHN;AAMI;EACE,2DAAA;AAJN;AAOI;EACE,qDAAA;AALN;AAQI;EACE,+BAAA;AANN;AAjBE;EA0BE,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,wBAAA;EACA,eAAA;EACA,eAAA;AANJ;AAQI;EACE,aAAA;EACA,mBAAA;AANN;AAQM;EACE,gBAAA;AANR;AAUI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AARN;AAWI;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AATN;AAYI;EACE,aAAA;EACA,mBAAA;AAVN;AAYM;EACE,iBAAA;AAVR;;AAgBA;EACE,cAAA;AAbF","sourcesContent":[".creators-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  grid-auto-rows: 1fr;\n  grid-gap: 40px 20px;\n  place-items: stretch;\n\n  .topic-creator-card {\n    max-width: 330px;\n  }\n}\n\n.creators-grid-highlight {\n  display: flex;\n  flex: 1;\n\n  a {\n    padding: 0;\n  }\n}\n\n.creators-list {\n  position: relative;\n  display: grid;\n  grid-template-columns: 1fr;\n\n  .creators-list-header {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n\n    &.with-tiktok,\n    &.with-twitch {\n      grid-template-columns: 24px 66px 230px repeat(7, 1fr) 180px;\n    }\n\n    &.default {\n      grid-template-columns: 24px 66px 230px repeat(5, 1fr) 180px;\n    }\n\n    &.with-twitch-tiktok {\n      grid-template-columns: 24px 66px 230px repeat(9, 1fr) 180px;\n    }\n\n    &.custom-header {\n      grid-template-columns: 36px 66px 230px repeat(5, 1fr);\n    }\n\n    .custom-header-label-selected {\n      color: var(--color_primary_500);\n    }\n\n    background: var(--background);\n    border-radius: 4px;\n    font-weight: bold;\n    display: grid;\n    grid-column-gap: 8px;\n    align-items: center;\n    justify-items: left;\n    height: 36px;\n    padding: 0 8px;\n    color: var(--gray_dark1);\n    font-size: 12px;\n    margin: 0 0 4px;\n\n    .list-header-tooltip {\n      display: flex;\n      align-items: center;\n\n      .QuestionMarkTooltip {\n        margin-left: 8px;\n      }\n    }\n\n    >div {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n    }\n\n    .provider {\n      margin: 0 4px 0 0;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .engag-ratio {\n      display: flex;\n      align-items: center;\n\n      span {\n        margin-right: 4px;\n      }\n    }\n  }\n}\n\n.header-modal-creators {\n  color: #4c5667;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
